import { combineReducers } from 'redux'
import * as types from 'models/actionTypes'

const initialState = {
    gtURLs: [],
    gtZipIsLoading: false,
    debugSettings: {
        linesViz: false,
        lightsViz: false,
        depthViz: false,
        imitateLowPerformance: false,
        ssViz: false,
        nsViz: false,
        normalsViz: false,
        environmentRotation: 2,
        environmentIntensity: 1.0,
        pointLightIntensities: new Array(10).fill(1),
        ambientLightIntensity: 1.0,
        directionalLightIntensities: new Array(10).fill(1),
        highlightPlanes: false,
        defaultToFloor: false,
        useFancyShadows: false,
        frontSideShadows: true,
        useMultiShadow: false,
        enableWalls: true,
        canEditArtSize: false,
        stackablesOnFloor: false,
        enableGPUframetimeStats: false,
        showMemoryStats: false,
        trackedMemoryType: 0,
        toneMappingType: 0, // = THREE.NoToneMapping,
        toneMappingExposure: 1.0,
        aoMapIntensity: 1.0,
        analyticLightsContribution: true,
        showProductAdminData: false,
        useTAAforScreenshots: false,
        hidePins: false,
    },
}

const gtURLs = (state = initialState.gtURLs, action) => {
    switch (action.type) {
        case types.RECEIVE_GT:
            return action.gtURLs
        default:
            return state
    }
}

const gtZipIsLoading = (state = initialState.gtZipIsLoading, action) => {
    switch (action.type) {
        case types.REQUEST_DOWNLOAD:
            return true
        case types.RECEIVE_DOWNLOAD:
            return false
        default:
            return state
    }
}

const debugSettings = (state = initialState.debugSettings, action) => {
    switch (action.type) {
        case types.UPDATE_DEBUG_SETTINGS:
            return {
                ...state,
                ...action.debugSettings,
                useMultiShadow: action.debugSettings.useFancyShadows || false,
            }
        default:
            return state
    }
}

export default combineReducers({
    gtURLs,
    gtZipIsLoading,
    debugSettings,
})
